import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/github-alt': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M186.1 328.7C186.1 349.6 175.2 383.8 149.4 383.8S112.7 349.6 112.7 328.7 123.6 273.6 149.4 273.6 186.1 307.8 186.1 328.7zM480 278.2C480 310.1 476.8 343.9 462.5 373.2 424.6 449.8 320.4 448 245.8 448 170 448 59.6 450.7 20.2 373.2 5.6 344.2 0 310.1 0 278.2 0 236.3 13.9 196.7 41.5 164.6 36.3 148.8 33.8 132.2 33.8 115.8 33.8 94.3 38.7 83.5 48.4 64 93.7 64 122.7 73 157.2 100 186.2 93.1 216 90 245.9 90 272.9 90 300.1 92.9 326.3 99.2 360.3 72.5 389.3 64 434.1 64 443.9 83.5 448.7 94.3 448.7 115.8 448.7 132.2 446.1 148.5 441 164 468.5 196.4 480 236.3 480 278.2zM415.7 328.7C415.7 284.8 389 246.1 342.2 246.1 323.3 246.1 305.2 249.5 286.2 252.1 271.3 254.4 256.4 255.3 241.1 255.3 225.9 255.3 211 254.4 196 252.1 177.3 249.5 159 246.1 140 246.1 93.2 246.1 66.5 284.8 66.5 328.7 66.5 416.5 146.9 430 216.9 430H265.1C335.4 430 415.7 416.6 415.7 328.7zM333.1 273.6C307.3 273.6 296.4 307.8 296.4 328.7S307.3 383.8 333.1 383.8 369.8 349.6 369.8 328.7 358.9 273.6 333.1 273.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/github-alt.js
// module id = Wrd9
// module chunks = 144